import { UserIconVariant } from '../Icon/variants/userIconVariants';
import { BenefitsDealCardVariant } from './types';

export const OVERLAY_TEXTS: Record<BenefitsDealCardVariant, string> = {
  noCouponsAvailable: 'Leider vergriffen',
  availableSoon: 'Bald verfügbar',
};

export const OVERLAY_ICONS: Record<BenefitsDealCardVariant, UserIconVariant> = {
  noCouponsAvailable: 'user/monkey-blind',
  availableSoon: 'user/hourglass',
};
